// extracted by mini-css-extract-plugin
module.exports = {"container":"featureLayout_container__oR_yi","feature":"featureLayout_feature__HN0vo"};